import { createContext } from 'react'

import type { OnboardingHeaders } from '@twisto/risk'

export const RiskHeadersContext = createContext<null | OnboardingHeaders>(null)
